/** The app's header: title, running count, and the way into settings. */
import { GearIcon, SearchIcon } from "@/components/Icon";

/**
 * Five taps on the title opens the measurement panel — see Diagnostics.
 *
 * It used to be five taps on the date above the title. The date said what
 * every phone already says in the status bar an inch higher, so it went; the
 * trigger moved to the title, which is the only thing in the header that is
 * always present.
 */
export function TopBar({
  title,
  count,
  showSettings,
  search,
  onSecretTap,
  onSettings,
  onSearch,
}: {
  title: string;
  count: string | null;
  /** Settings live on Search, not on every screen. */
  showSettings: boolean;
  /** The Library's own filter: null when closed, a string when open. */
  search: string | null;
  onSecretTap: () => void;
  onSettings: () => void;
  onSearch: ((query: string | null) => void) | null;
}) {
  if (search !== null && onSearch !== null) {
    return (
      <header className="topbar searching">
        <div className="searchbar">
          <SearchIcon />
          <input
            type="search"
            value={search}
            placeholder="Search your library"
            autoComplete="off"
            autoFocus
            onChange={(event) => {
              onSearch(event.target.value);
            }}
          />
        </div>
        <button
          type="button"
          className="quiet"
          onClick={() => {
            onSearch(null);
          }}
        >
          Done
        </button>
      </header>
    );
  }

  return (
    <header className="topbar">
      <span className="title-wrap">
        <h1 onClick={onSecretTap}>{title}</h1>
      </span>
      {count !== null && <span className="count">{count}</span>}
      {onSearch !== null && (
        <button
          type="button"
          className="settings-open"
          aria-label="Search your library"
          onClick={() => {
            onSearch("");
          }}
        >
          <SearchIcon />
        </button>
      )}
      {showSettings && (
        <button type="button" className="settings-open" aria-label="Settings" onClick={onSettings}>
          <GearIcon />
        </button>
      )}
    </header>
  );
}
